import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import NotificationType from 'core/helpers/notifications';
import { NotificationCard } from 'core/components/notification-card';
import { useStore } from 'core/store';
import { CrossSellEligibilityNotification } from '../cross-sell-eligibility-notification';

const Notification = {
  [NotificationType.Customer.CrossSellEligibility]: CrossSellEligibilityNotification
};

const CustomerNotifications = observer(({ type }) => {
  const {
    account: { notifications }
  } = useStore();
  return (
    <Grid id="notificationsContainer">
      {notifications?.map((notificationType) => {
        const NotificationComponent = Notification[notificationType];
        return (
          <NotificationCard key={notificationType} type={type}>
            <NotificationComponent />
          </NotificationCard>
        );
      })}
    </Grid>
  );
});

export default CustomerNotifications;
